import React, { useState } from 'react';
import { Dialog, Grid, Box, Typography, useMediaQuery } from '@mui/material';
import Signup from '../../components/Signup/Signup'
import Login from '../../components/Login/Login'
import ForgotPassword from '../../components/ForgotPassword/ForgotPassword'
import CrossIcon from '../../images/crossIcon3.svg'
import { appTheme } from '../../theme';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import CheckIcon from '@mui/icons-material/Check';
import { EventStatus } from '../../services/Types';
import { flexItemCenter, flexrow } from '../../global'
import { useStyles } from './style'
import { EventGridCompact } from '../../components/EventGrid/EventGridCompact';

interface CalendarDialogsProps {
  openAllEvents: boolean;
  setOpenAllEvents: (open: boolean) => void;
  role?: string;
  eventQueue: any[];
  handleCancelEvent: (id: number) => void;
  handleRevertEvent: (id: number) => void;
}

export const CalendarDialogs = ({
  openAllEvents,
  setOpenAllEvents,
  role,
  eventQueue,
  handleCancelEvent,
  handleRevertEvent
}: CalendarDialogsProps) => {
  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'));
  const [auth, setAuth] = useState(true);
  
  // Move state and handlers into component
  const [openModal, setOpenModal] = useState(false);
  const [signupModal, setSignupModal] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);

  const classes = useStyles()

  const handleClose = () => setOpenModal(false);
  const handleOpen = () => {
    setOpenModal(true);
    setSignupModal(false);
    setForgotPasswordModal(false);
    setResetPasswordModal(false);
  };
  
  const handleSignupClose = () => setSignupModal(false);
  const handleSignupOpen = () => {
    setSignupModal(true);
    setOpenModal(false);
    setForgotPasswordModal(false);
    setResetPasswordModal(false);
  };
  
  const handleForgotPasswordClose = () => setForgotPasswordModal(false);
  const handleForgotPasswordOpen = () => {
    setForgotPasswordModal(true);
    setOpenModal(false);
    setSignupModal(false);
    setResetPasswordModal(false);
  };
  
  const handleResetPasswordOpen = () => {
    setResetPasswordModal(true);
    setOpenModal(false);
    setSignupModal(false);
    setForgotPasswordModal(false);
  };

  const getStatusStyle = (status: string) => {
    var label = '';
    var color = '';
    if (
      (status === EventStatus.APPROVAL3 ||
        status === EventStatus.APPROVAL2 ||
        status === EventStatus.APPROVAL1) &&
      role === 'REQUESTER'
    ) {
      label = 'Pending Approval';
      color = '#FF5722';
    } else if (status === EventStatus.APPROVAL2) {
      label = 'Approval Level 2';
      color = '#FF5722';
    } else if (status === EventStatus.APPROVAL3) {
      label = 'Approval Level 3';
      color = '#0288D1';
    } else if (status === EventStatus.APPROVAL1) {
      label = 'Approval Level 1';
      color = '#6200EA';
    } else if (status === EventStatus.SAVED) {
      label = 'Unsubmitted';
      color = '#455A64';
    } else if (status === EventStatus.APPROVED) {
      label = 'Approved';
      color = '#009A44';
    }

    const getIconBgColor = () => {
      const opacity = 0.12;
      var _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
      return color + _opacity.toString(16).toUpperCase();
    };

    return (
      <Box style={flexrow} sx={{ alignItems: 'center' }}>
        <Box
          style={flexItemCenter}
          sx={{
            height: '1.5rem',
            width: '1.5rem',
            borderRadius: '50%',
            bgcolor: getIconBgColor,
            mr: 1
          }}
        >
          {status === 'Unsubmitted' || status === 'Pending' ? (
            <QuestionMarkIcon
              sx={{ fontSize: '12px', opacity: 100, color: { color } }}
            />
          ) : (
            <CheckIcon sx={{ fontSize: '12px', color: { color } }} />
          )}
        </Box>
        <Typography sx={{ fontWeight: 400, fontSize: '12px' }} color={color}>
          {label}
        </Typography>
      </Box>
    );
  };

  const AllEventsTableColumns = [
    {
      title: 'Title',
      width: role ? '43%' : '60%'
    },
    {
      title: 'Request Date',
      width: role ? '27%' : '40%'
    },
    {
      title: 'Status',
      width: '15%'
    },
    {
      title: 'Action',
      width: '15%'
    }
  ]
  const AllEventsTableColumnsWidth = AllEventsTableColumns.map(obj => obj.width)

  return (
    <Grid>
      {/* //All Event Popup */}
      <Dialog
        fullScreen={fullScreen}
        maxWidth='lg'
        open={openAllEvents}
        onClose={() => setOpenAllEvents(false)}
        PaperProps={{
          style: {
            borderTopRightRadius: '24px',
            borderTopLeftRadius: '24px',
            borderBottomRightRadius: '12px',
            borderBottomLeftRadius: '12px',
            paddingLeft: '24px',
            paddingRight: '18px',
            paddingBottom: '3px',
            width: '983px'
          }
        }}
      >
        <Box style={flexrow} sx={{ justifyContent: 'space-between'}}>
          <Typography variant='h2'>
            All events
          </Typography>
          <Box
            onClick={() => setOpenAllEvents(false)}
            sx={{
              ml: '15px',
              mt: '22px',
              width: '12px',
              height: '12px',
              cursor: 'pointer'
            }}
            component='img'
            src={CrossIcon}
            alt='CrossIcon'
          />
        </Box>
        <EventGridCompact searchCriteria={EventStatus.SAVED} allEvents={false} />
      </Dialog>

      {/* //Login , Sigup, Forgot Password popup */}
      <Dialog
        fullScreen={fullScreen}
        className={classes.modalBox}
        open={openModal}
        onClose={handleClose}
      >
        <Login
          classList={'hidden'}
          handleForgotPasswordOpen={handleForgotPasswordOpen}
          handleLoginOpen={handleOpen}
          handleSignupOpen={handleSignupOpen}
          handleResetPasswordOpen={handleResetPasswordOpen}
          modelClose={handleClose}
          loginPage={auth}
        />
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        className={classes.modalBox}
        open={signupModal}
        onClose={handleSignupClose}
      >
        <Signup
          classList={'hidden'}
          handleLoginOpen={handleOpen}
          modelClose={handleSignupClose}
          signupPage={auth}
        />
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        className={classes.modalBox}
        open={forgotPasswordModal}
        onClose={handleForgotPasswordClose}
      >
        <ForgotPassword
          classList={'hidden'}
          handleLoginOpen={handleOpen}
          modelClose={handleForgotPasswordClose}
          handleResetPasswordOpen={handleResetPasswordOpen}
        />
      </Dialog>
    </Grid>
  );
};

export default CalendarDialogs; 